import React from 'react';
import { Col, Layout, Typography, Row } from 'antd';
import AddToInput from '../icons/showcase-add-to-input.svg';
import { RightOutlined } from '@ant-design/icons';
import { useIsMobile } from '../hooks/screen-size';
import TopNavBar from './top-nav-bar';
import { useNavigate } from 'react-router-dom';
import BottomNavBar from './bottom-nav-bar';
import { useSelector } from 'react-redux';
import { getSideSuggestions } from '../utils/utils';
const { Sider } = Layout;
const { Text } = Typography;

// Reusable component for rendering suggestions
const SuggestionList = ({ title, suggestions, setQuestionText }) => (
  <div style={{ paddingTop: '16px' }}>
    <Text
      style={{
        margin: '20px',
        color: '#64778E',
        fontSize: '13px',
        fontWeight: 600,
      }}
    >
      {title}
    </Text>
    <br />
    {suggestions.map((suggestion, index) => (
      <Row
        key={index}
        className="suggestion"
        onClick={() => setQuestionText(suggestion)}
      >
        <Col span={2}>
          <img width="24px" height="24px" src={AddToInput} alt="Add to input" />
        </Col>
        <Col span={20}>
          <Text ellipsis className="question-text" strong>
            {suggestion}
          </Text>
        </Col>
        <Col span={2} className="actions">
          <button className="use-button">USE THIS</button>
          <RightOutlined
            style={{
              color: '#7A8B94',
              fontSize: 18,
              strokeWidth: '40',
              stroke: '#7A8B94',
            }}
          />
        </Col>
      </Row>
    ))}
  </div>
);

const ShowcaseSuggestionsContext = ({ setQuestionText, isMobile }) => {
  const navigate = useNavigate();
  const handleQuestionClick = (question) => {
    if (isMobile) {
      navigate('/', { state: { question } });
    } else {
      setQuestionText(question);
    }
  };
  const {selectedBot} = useSelector(state => state?.bots)
  return (
    <>
      {isMobile && (
        <>
          <div style={{ height: '7vh' }}></div>
          <TopNavBar />
        </>
      )}
      <Text
        style={{ fontWeight: 600, fontSize: '18px', margin: '20px 0 0 20px' }}
      >
        Suggestions
      </Text>
      {getSideSuggestions(selectedBot)?.map((el) => {
        return (
          <SuggestionList
            key={el?.title}
            title={el?.title}
            suggestions={el?.questions}
            setQuestionText={(el) => {
              handleQuestionClick(el);
            }}
          />
        );
      })}
    </>
  );
};
function ShowcaseSuggestions({ setQuestionText }) {
  const isMobile = useIsMobile();
  return (
    <>
      {isMobile ? (
        <div
          style={{
            height: '94vh',
            backgroundColor: 'white',
            borderLeft: '1px solid #f0f0f0',
            overflow: 'scroll',
            marginBottom: '6vh',
          }}
        >
          <br />
          <ShowcaseSuggestionsContext
            setQuestionText={setQuestionText}
            isMobile={isMobile}
          />
          <div
            style={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 100,
              paddingTop:'10px',
              backgroundColor: 'white',
            }}
          >
            <BottomNavBar />
          </div>
        </div>
      ) : (
        <Sider
          width="32%"
          style={{
            height: '100vh',
            backgroundColor: 'white',
            borderLeft: '1px solid #f0f0f0',
            overflow: 'scroll',
          }}
        >
          <br />
          <ShowcaseSuggestionsContext setQuestionText={setQuestionText} />
        </Sider>
      )}
    </>
  );
}

export default ShowcaseSuggestions;
